import Biblioteca from '@/components/Repositorio/Biblioteca.js'

export default {
  async buscarVisoesFinanceiras(api, parametros) {        
    parametros.operacao = 'buscarVisoesFinanceiras'

    let retorno = {}

    await api.santriPOST('/rest/visoesFinanceiras', parametros, 0, false)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data)
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined)
    })

    return retorno;
  }
}


// WEBPACK FOOTER //
// ./src/components/Rest/RVisoesFinanceiras.js